/**
 * BNT Asistente — botón flotante, barra de tareas (dock) y auto-apertura del panel.
 * No confundir con el widget de IA de Emergent (visual-edits, icono PDF en dev).
 */
export const BNT_ASISTENTE_FLOATING_UI_ENABLED = true;

/** @deprecated Alias histórico — usar BNT_ASISTENTE_FLOATING_UI_ENABLED */
export const BNT_ASISTENTE_VIRTUAL_IA_UI_ENABLED = BNT_ASISTENTE_FLOATING_UI_ENABLED;

export function isBntAsistenteFloatingUiEnabled() {
  return BNT_ASISTENTE_FLOATING_UI_ENABLED;
}
